import { SystemOption, SystemListMessage } from '../types';

export const SystemEvent = {
  /**
   * When any of the `SystemOption` is clicked from a `SystemListMessage`.
   * @see SystemOption
   * @see SystemListMessage
   */
  LIST_OPTION_SELECTED: 'sys:option:selected',
  /**
   * When the user clicks yes no from a response message.
   */
  USER_RESOLUTION_SELECTED: 'sys:resolution:selected',
  /**
   * When an article with preview is expanded.
   */
  ARTICLE_PREVIEW_EXPANDED: 'sys:article:expanded',
  /**
   * If none of the above is visible and selected, then this event is emitted.
   */
  NONE_OF_THE_ABOVE_SELECTED: 'sys:option:noneOfTheAbove',
  /**
   * When the user clicks an interactive message that can be rolled back.
   */
  USER_ROLLBACK: 'sys:rollback',
} as const;
